import { Observable } from 'rxjs';
import { UseCase } from '../../base/use-case';
import { DataTypeMimeModel, TypeMimeModel } from '../../models/academy/type-mime.model';
import { AcademyRepository } from '../../repositories/academy.repository';

export class InsertTypeMimeUseCase implements UseCase<DataTypeMimeModel, TypeMimeModel> {
  constructor(private repository: AcademyRepository) {}

  execute(params:DataTypeMimeModel): Observable<TypeMimeModel> {
    return this.repository.insertTypeMime(params);
  }
}
